import { useEffect, useState, createRef, useCallback } from "react";
import PropTypes from "prop-types";
import BreadCrumb from "../../components/atoms/breadCrumb/BreadCrumb";
import {
  connect,
  Container,
  CustomContainer,
} from "../../components/atoms/DependencyHelper";
import UpgradeFiltersModal from "../../components/molecules/UpgradeFiltersModal/UpgradeFiltersModal";
import UpgradeTopContainer from "../../components/molecules/upgradeTopContainer/UpgradeTopContainer";
import UpgradeCarousel from "../../components/organisms/UpgradeCarousel/UpgradeCarousel";
import UpgradeDealsPageContainer from "../../components/organisms/upgradeDealsPageContainer/UpgradeDealsPageContainer";
import { getDeviceModels, getLookupData, getRecommendedDeals, fetchDisplayDetails, setSelectedDisplayData } from "../../Redux/actions/upgradeAction";
import { breadcrumbGenerator } from "../../services/breadcrumbService";
import { createFilterRequestForDealSelection, getSortQueryForDeals } from "../../services/filterDealService";
import { upgradeStages } from "../../services/upgradeService";
import ajaxService from "../../utils/ajaxServices";
import { componentCheckSize, formatBreadCrumb, hideSpinner, showSpinner, debounce } from "../../utils/helperServices";
import * as Analytics from "../../services/analyticsUtag";
import labels from "../../config/labels";
import ErrorPage from "../../components/molecules/errorPage/errorPage";
const k8sConfig = typeof window === "undefined" ? require("config") : "";

const UpgradePage = (props) => {
  // const [resultData, setResultData] = useState({});
  const [brands, setBrands] = useState([]);
  const [models, setModels] = useState([]);
  const windowSize = componentCheckSize();
  const isMobile = componentCheckSize() < 577;
  const isTablet = componentCheckSize() < 992;
  const [staticText, setStaticText] = useState(null);
  const [carouselData, setCarouselData] = useState(null);
  const [simpleCardData, setSimpleCardData] = useState(null);
  const [displayLanding, setDisplayLanding] = useState(true);
  const [selectedContractType, setSelectedContractType] = useState(labels.upgrade.planData.lbl_contract_with_device);
  const [selectedBrand, setSelectedBrand] = useState();
  const [selectedModel, setSelectedModel] = useState();
  const [showModal, setShowModal] = useState(false);
  const [dealSkus, setDealSkus] = useState([]);
  const [selectedNumber, setSelectedNumber] = useState(props.unMaskedMsisdn);
  const [selectedDealFilter, setSelectedDealFilter] = useState([]);
  const [loadingProducts, setLoadingProducts] = useState(true);
  const [isAlternate, setisAlternate] = useState(false);
  let [productList, setProductList] = useState();
  let [currentPage, setCurrentPage] = useState(
    productList?.products?.page_info?.current_page || 1
  );
  const [sortBy, setSortBy] = useState(labels.sortKeys.lbl_recommended);
  const [pastUsageParagraph, setPastUsageParagraph]= useState();
  const [isPrevious, setIsPrevious] = useState(!!props.msisdn);
  const [positionX, setPositionX] = useState(0);
  const [isContractTypeFilterApplied, setContractTypeFilterApplied] = useState(false);
  const [isBrandFilterApplied, setBrandFilterApplied] = useState(false);
  const [isModelFilterApplied, setModelFilterApplied] = useState(false);
  const planData = [
    labels.upgrade.planData.lbl_contract_with_device,
    labels.upgrade.planData.lbl_contract_sim_only,
  ];
  const mainContainerRef = createRef();

  useEffect(() => {
    const { current } = mainContainerRef;
    if (current) {
      const elemRect = current.getBoundingClientRect();
      setPositionX(elemRect.x);
    }
  }, [mainContainerRef]);

  useEffect(() => {
    window.scrollTo(0,0);
    async function fetchContent () {
      try{
        const resultData = await ajaxService.httpGet(
          "drupalBaseUrl",
          "",
          "api",
          "upgradeEligibleCheck"
        );
        if(resultData){
          for (let i = 0; i < resultData.sections.length; i++) {
            switch (resultData.sections[i].type) {
              case "paragraph_list":
                setStaticText(resultData.sections[i]);
                break;
              case "small_card_image_carousel":
                if (resultData.sections[i].cardType == "Carousel") {
                  setCarouselData(resultData.sections[i]);
                } else {
                  setSimpleCardData(resultData.sections[i]);
                }
                break;
              case "paragraph":
                if (resultData.sections[i].analyticTitle == "Upgrade usage - Past Usage and Spend") {
                  setPastUsageParagraph(resultData.sections[i])
                }
                break;
              default:
            }
          }
        }
        return resultData;
      }
      catch(e) {
        console.log("Error", e)
      }
    }
    fetchContent();
  }, []);

  useEffect(() => {
    if (!displayLanding && props?.creditFilters?.total_monthly_payment){
      setProductList();
      props.getLookupData();
      props.getRecommendedDeals(
        props.upgradeResponse?.msisdn,
        "","","",
        props.creditFilters?.total_monthly_payment,
        props.creditFilters?.deviceInstallment,
        props.creditFilters?.financeIndicator,
        "",
        props.upgradeResponse?.simOnlyUpgradeFlg);
    }
  }, [props.upgradeResponse.msisdn,displayLanding,props.creditFilters?.total_monthly_payment]);

  useEffect(() => {
    setBrands(props.manufacturers?.sort());
  }, [props.manufacturers]);

  useEffect(() => {
    if (selectedBrand) {
      props.getDeviceModels(selectedBrand);
    }
  }, [selectedBrand])

  useEffect(() => {
    let modelsArr = [];
    for (let i = 0; i < props.deviceModels?.length; i++) {
      modelsArr.push(props.deviceModels[i].model);
    }
    setModels(modelsArr);
  }, [props.deviceModels]);

  useEffect(() => {
    if (
      props.resultCode &&
      (props.journeyStatus === upgradeStages.UPGRADE_RESULT ||
        props.journeyStatus === upgradeStages.TECHNICAL_ERROR)
    ) {
      props.fetchDisplayDetails(props.resultCode);
    }
  }, [props.journeyStatus, props.resultCode]);

  useEffect(() => {
    let dealArr = []
    if (props.recommendedSkus?.length > 0) {
      for (let i = 0; i < props.recommendedSkus.length; i++) {
        dealArr.push(props.recommendedSkus[i].dealsheetNumber)
      }
      setDealSkus(dealArr);
    } else {
      setDealSkus([]);
    }
  }, [props.recommendedSkus])

  const searchDeals =()=>{
    setProductList();
    props.getRecommendedDeals(
      selectedNumber,
      selectedContractType === labels.upgrade.planData.lbl_contract_sim_only ? "Y" : "",
      selectedBrand,
      selectedModel,
      props.creditFilters?.total_monthly_payment,
      props.creditFilters?.deviceInstallment,
      props.creditFilters?.financeIndicator,
      "",
      props.upgradeResponse?.simOnlyUpgradeFlg
    );
  }

  const updateCurrentPage = (page) => {
    setCurrentPage(page);
  };
  // let dealArr=["DV20K28630","DV20K28622","DV0JD08419","DV20K28629","DV20K28625","DV0JD08417","DV0JD05135","DV20K28627","DV20K28623","DV0JD08419"];

  useEffect(() => {
    if (dealSkus.length > 0) {
      fetchData();
    }
  }, [dealSkus,currentPage])
  useEffect(()=>{
    fetchData();
  },[sortBy]);

  const resetFilter = () => {
    setSelectedDealFilter([]);
  }

  const pageSize = ()=> {
    let size= "12";
    if (windowSize < 576) {
      size="8";
    } else if (windowSize > 576 && windowSize <992) {
      size="10";
    } else {
      size= "12";
    }
    return size;
  }

  const fetchData = async () => {
    const sortParam = getSortQueryForDeals(sortBy);
    if (dealSkus?.length > 0) {
      showSpinner();
      setLoadingProducts(true);
      const result = await createFilterRequestForDealSelection(
        dealSkus,
        pageSize(),
        sortParam,
        currentPage,
        selectedDealFilter,
        "",
        "upgrade"
      ).finally(()=>{
        hideSpinner();
      });
      if (result) {
        setLoadingProducts(false)
        setProductList(result);
      }
    }
  }

  const analyticsHandleSortFilter = (value) => {
    Analytics.link({
      ...Analytics.getUtagData([
        "page_name",
        "page_channel",
        "page_master_tab",
        "sales_product_id",
        "sales_product_price",
        "sales_product_quantity",
        "page_site_section_lvl_1",
        "page_site_section_lvl_2",
        "page_site_section_lvl_3",
        "visitor_customer_id",
        "visitor_id_hash",
        "visitor_msisdn_hash",
        "visitor_subscription_type",
      ]),
      page_tool_event: "use",
      page_tool_name: "shopping: deal selection: sort by filter",
      filter_query: value,
    });
  };

  useEffect(()=>{
    const isIE = /*@cc_on!@*/false || !!document.documentMode;
    if(isIE) {
      const el = document.querySelector("div[class*='NavItems_menu-sub']");
      if(el) {
        el.classList.add('d-none');
      }
      window.scroll(0,0);
    }
    if(isMobile) {
      window.scroll(0,0);
    }
  },[]);

  const LandingPage = () => {
    return (
      <CustomContainer>
        <CustomContainer>
          {staticText && (
            <UpgradeTopContainer
              selectedNumber={selectedNumber}
              staticText={staticText}
              setSelectedNumber={setSelectedNumber}
              isPrevious={isPrevious}
              setIsPrevious={setIsPrevious}
              isAlternate={isAlternate}
              setisAlternate={setisAlternate}
            />
          )}
        </CustomContainer>
      </CustomContainer>
    );
  };

  useEffect(()=>{
    async function setDisplayData(){
      if(props?.upgradeResponse?.resultCode){
        const result = await ajaxService.httpGet(
          "drupalBaseUrl",
          "",
          "api",
          "upgradeResult",
          [props.upgradeResponse.resultCode.toLowerCase()]
        );
        if(result && result.length){
          props.setSelectedDisplayData(result[0])
        }
      }
    }
    setDisplayData();
  },[props.upgradeResponse])

  const SecondPage = () => {
    return (
      <>
        <UpgradeDealsPageContainer
          setSelectedContractType={setSelectedContractType}
          setSelectedBrand={setSelectedBrand}
          setSelectedModel={setSelectedModel}
          brands={brands}
          models={models}
          planData={planData}
          selectedContractType={selectedContractType}
          selectedNumber={selectedNumber}
          setSelectedNumber={setSelectedNumber}
          selectedBrand={selectedBrand}
          productList={productList}
          setSortBy={setSortBy}
          sortBy={sortBy}
          updateCurrentPage={updateCurrentPage}
          resetFilter={resetFilter}
          upgradeDisplayData={props.upgradeDisplayData}
          analyticsHandleSortFilter={analyticsHandleSortFilter}
          searchDeals={searchDeals}
          pastUsageParagraph={pastUsageParagraph}
          loadingProducts={loadingProducts}
          selectedModel={selectedModel}
          setShowModal={setShowModal}
          simpleCardData={simpleCardData}
          dealApiError={props.dealApiError}
          isContractTypeFilterApplied={isContractTypeFilterApplied}
          isBrandFilterApplied={isBrandFilterApplied}
          isModelFilterApplied={isModelFilterApplied}
          dealSkus={dealSkus}
          />

        <UpgradeFiltersModal
          showModal={showModal}
          setShowModal={setShowModal}
          setSortBy={setSortBy}
          setSelectedContractType={setSelectedContractType}
          setSelectedBrand={setSelectedBrand}
          setSelectedModel={setSelectedModel}
          selectedContractType={selectedContractType}
          selectedBrand={selectedBrand}
          selectedModel={selectedModel}
          brands={brands}
          models={models}
          products={productList}
          planData={planData}
          applyFilters={searchDeals}
          setContractTypeFilterApplied={setContractTypeFilterApplied}
          setBrandFilterApplied={setBrandFilterApplied}
          setModelFilterApplied={setModelFilterApplied}
        />
      </>
    );
  };

  const debouncedAnalytics = useCallback(
		debounce((upgradeCheckDone, userMetaData) => viewAnalytics(upgradeCheckDone,userMetaData), 800),
		[], // will be created only once initially
	);
 const viewAnalytics = (upgradeCheckDone, userMetaData) =>{
    if(!upgradeCheckDone){
      Analytics.view({
        page_event: "view",
        page_name: (props.msisdn || isPrevious) ? "shopping: upgrade: eligibility: another number" : "shopping: upgrade: eligibility",
        page_channel: "shopping",
        page_master_tab: "personal",
        ...userMetaData,
        page_site_section_lvl_1: "upgrade",
        page_site_section_lvl_2: "home",
      });
    } else{
      Analytics.view({
        page_event: "view",
        page_name: "shopping: upgrade: recommended deals",
        page_channel: "shopping",
        page_master_tab: "personal",
        ...userMetaData,
        upgrade_eligibility_status: `${props.upgradeResponse?.upgradeEligible ? props.upgradeResponse.upgradeEligible : false}`,
        upgrade_eligible_date: props.upgradeResponse?.upgradeDate || null,
        upgrade_customer_type: !props.upgradeResponse ? null : props.upgradeResponse?.c3dCustomer ? "C3D" : props.upgradeResponse?.business ? "EBU" : "Legacy",
      });
    }
 }
  useEffect(() => {
    if (props.upgradeCheckDone && props.upgradeResponse?.upgradeEligible) {
      setDisplayLanding(false);
      setisAlternate(false);
    } else {
      setSelectedNumber(props.unMaskedMsisdn);
      setIsPrevious(!!props.msisdn);
      setDisplayLanding(true);
    }
    window.scroll(0,0);
    const userMetaData = Analytics.getProfileData(
      props.userLoggedIn,
      props.profileData,
      props.authDetails
    );
    if(props.upgradeChecksEnabled && !isAlternate){
      debouncedAnalytics(props?.upgradeCheckDone, userMetaData);
    }
  }, [props.upgradeCheckDone, isAlternate]);

  useEffect(() => {
    setIsPrevious(!!props.msisdn);
  }, [props?.msisdn]);

  useEffect(()=>{
      const userMetaData = Analytics.getProfileData(
        props.userLoggedIn,
        props.profileData,
        props.authDetails
      );
    if(isAlternate && props.linkedNumbers?.length){
      Analytics.view({
        page_event: "view",
        page_name: "shopping: upgrade: eligibility: send otp",
        page_channel: "shopping",
        page_master_tab: "personal",
        ...userMetaData,
        page_site_section_lvl_1: "upgrade",
        page_site_section_lvl_2: "home",
      });
    }
  },[isAlternate, props.linkedNumbers])
  return (
    <>
    {
      props.upgradeChecksEnabled ? (<>
       <CustomContainer className={isMobile || isTablet ? "upgrade container-fluid" : "upgrade container"}>
        <CustomContainer ref={mainContainerRef} className="upgrade__breadcrumb">
          <BreadCrumb
            list={formatBreadCrumb(breadcrumbGenerator().upgradePage)}
          />
        </CustomContainer>
        {displayLanding ? LandingPage() : SecondPage()}
        {/* {LandingPage()} */}
      </CustomContainer>
      {displayLanding && (
        <Container fluid>
          {carouselData && <UpgradeCarousel positionX={positionX} carouselData={carouselData} />}
        </Container>
      )}
       </>):(
         <ErrorPage statusCode = {404} />
       )
    }
    </>
  );
};

UpgradePage.propTypes = {
  manufacturers: PropTypes.any,
  deviceModels: PropTypes.any,
  recommendedSkus: PropTypes.any,
  upgradeDisplayData: PropTypes.any,
  resultCode: PropTypes.any,
  journeyStatus: PropTypes.any,
  upgradeCheckDone: PropTypes.any,
  upgradeResponse: PropTypes.any,
  msisdn: PropTypes.any,
  unMaskedMsisdn: PropTypes.any,
  profileData: PropTypes.any,
  userLoggedIn: PropTypes.any,
  authDetails: PropTypes.any,
  allUpgradesData: PropTypes.any,
  creditFilters: PropTypes.any,
  linkedNumbers: PropTypes.any,
  dealApiError: PropTypes.any,
  upgradeChecksEnabled: PropTypes.bool,
  getLookupData: PropTypes.func,
  getDeviceModels: PropTypes.func,
  getRecommendedDeals: PropTypes.func,
  fetchDisplayDetails: PropTypes.func,
  setSelectedDisplayData: PropTypes.func
};

export const getServerSideProps = async () => {
  const upgradeChecksEnabled = k8sConfig.get("features.upgradeChecks");
  return {
    props:{
      upgradeChecksEnabled: upgradeChecksEnabled === "true"
    }
   };
};

const mapStateToProps = (state) => ({
  manufacturers: state.upgrade.manufacturers,
  deviceModels: state.upgrade.deviceModels,
  recommendedSkus: state.upgrade.recommendedSkus,
  upgradeDisplayData:state.upgrade.selectedUpgradeDisplayData,
  resultCode: state.upgrade.resultCode,
  journeyStatus: state.upgrade.upgradeStatus,
  upgradeCheckDone: state.upgrade.upgradeCheckDone,
  upgradeResponse: state.upgrade.selectedUpgradeResponse,
  msisdn:state.upgrade.msisdn,
  unMaskedMsisdn:state.upgrade.unMaskedMsisdn,
  profileData: state.navDetails.profileData,
  authDetails: state.checkoutDetails.authDetails,
  userLoggedIn: state.navDetails.isUserLoggedIn,
  allUpgradesData: state.upgrade.allUpgradesData,
  creditFilters:state.upgrade.creditFilters,
  linkedNumbers: state.upgrade.linkedNumbers,
  dealApiError:state.upgrade.dealApiError
})

export default connect(mapStateToProps, { getLookupData, getDeviceModels, getRecommendedDeals,fetchDisplayDetails, setSelectedDisplayData })(UpgradePage);
